module.exports = require('./helpers/bundle-url').getBundleURL('kmvYf') + "alfried-laengle.ca3dcf47.jpg" + "?" + Date.now();